import types from './types';

// Rows carry an unsaved-state prefix while edits are pending; the backend id
// is what identifies a row across those states (mirrors
// NetworkTable/helpers getPersistedNetworkId — rows created locally have none).
const TEMP_ID_PREFIX = /^(new-|edited-|deleted-)/;
const getPersistedId = id => {
  if (!id || id.startsWith('new-')) {
    return null;
  }

  return id.replace(TEMP_ID_PREFIX, '');
};

const reducer = (state, action) => {
  const newState = { ...state };

  switch (action.type) {
    case types.UPDATE_NETWORK_DETAILS: {
      const deletedIds = action.payload.deleted.map(({ tempId }) => tempId);

      const newData = action.payload.success.reduce(
        (acc, { tempId, ...item }) => {
          const index = acc.findIndex(({ id }) => id === tempId);
          acc.splice(index, 1, item);
          return acc;
        },
        [...newState.networkDetails.data],
      );

      const filteredData = newData.filter(({ id }) => !deletedIds.includes(id));

      return {
        ...newState,
        networkDetails: {
          data: [...filteredData],
          error: action.payload.error,
        },
      };
    }
    // Applied against the reducer's current rows on purpose: a component-side
    // patch built from rows captured at click time would silently revert
    // edits/deletes made while the request was in flight (PR review).
    case types.PATCH_NETWORK_DETAILS_ROW: {
      const { persistedId, changes } = action.payload;

      return {
        ...newState,
        networkDetails: {
          ...newState.networkDetails,
          data: newState.networkDetails.data.map(row => {
            return getPersistedId(row.id) === persistedId
              ? { ...row, ...changes }
              : row;
          }),
        },
      };
    }
    case types.SET_NETWORK_DETAILS_UNSAVED_CHANGES:
      return {
        ...newState,
        networkDetails: {
          ...newState.networkDetails,
          unsavedChanges: action.payload,
        },
      };
    case types.SET_NETWORK_DETAILS:
      return {
        ...newState,
        networkDetails: {
          data: action.payload,
          error: {},
          loading: false,
        },
      };

    default:
      return newState;
  }
};

export default reducer;
